import { BookingStepTopBar } from "../components/BookingStepTopBar"
import { PriceDetailsCard } from "../components/PriceDetailsCard"

export const Cart = () => {

    return (
        <div className="w-full">
            <BookingStepTopBar />
            <div className="w-full bg-gray-100 min-h-screen pt-20 pb-4 px-10 flex justify-between">
                <div className="w-full flex flex-col items-center space-y-8">
                    {/* <TireDetailCard page="cart" /> */}
                </div>
                <PriceDetailsCard />
            </div>
        </div>
    )
}